// import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import Header from "../../../Component/Header";
import Menu from "../../../Component/Menu";
import Footer from "../../../Component/Footer";
import { Link, useNavigate } from "react-router-dom";
import TourServices from "../../Invoice/TourServices";
import { TextField } from "@mui/material";
import { currentTenant, currentUser } from "../../../Common/Credentials";
import withRouter from "../../../withRouter";
import moment from "moment";


const MHotelTax = (props) => {
  const [checked, setChecked] = useState(true);
  const nevigate = useNavigate();
  const [data, setData] = useState({
    id: 0,
    code: "",
    name: "",
    createddate:new Date(),
    modifieddate:new Date(),
    tenantid:currentTenant
    
  });
 

  useEffect(() => {
    console.log(props.location.state.id);
    if(props.location.state.id !== -1)
    {
        TourServices.getByIdMHotelTax(props.location.state.id).then((r)=>{
        setData({
         
          code: r.data.code,
          name: r.data.name,
          createddate:r.data.createddate,
          modifieddate:data.modifieddate,
          tenantid:r.data.tenantid,
        }) 
        
        
        })
    }
  },[])

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const changeHandler = (e) => {
    setData(prevValues => {
      return { ...prevValues, [e.target.name]: e.target.value }
    })
  }

  const AddHandler = (e) => {
   
    e.preventDefault();
    if(props.location.state.id == -1)
    {
      const sdata = {
      
        code: data.code,
        name: data.name,
        createddate:new Date(),
        modifieddate:new Date(),
        tenantid:currentTenant,
        
      }
      TourServices.addMHotelTax(sdata).then((r) => {
        console.log(r.data);
      })
      nevigate("/hotelMastertaxList");
    }
    else
    {
      const sdata = {
      
        code: data.code,
        name: data.name,
        createddate:data.createddate,
        modifieddate:new Date(),
        tenantid:currentTenant,
        
      }
      TourServices.updateMHotelTax(sdata,props.location.state.id).then((r) => {
        console.log(r.data);
      })
      nevigate("/hotelMastertaxList");
    }

  }


  return (
    <>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card">
          <ol className="breadcrumb float-sm-right">
          <span
                as="button"
                className=" text-secondary cursorPointer"
                
              >
                <Link to="/hotelMastertaxList" style={{color:"grey"}}>❮ Back &nbsp;&nbsp;</Link>
                
              </span>
            <li className="breadcrumb-item text-secondary">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item text-secondary">
              <Link to="/masterpage">Tours & Travellers </Link>
            </li>
            <li className="breadcrumb-item active">Master Hotel Tax</li>
          </ol>
          <div className="">
            <form >
              <div className="card-body p-6">
                <div className="row my-1">
                  <fieldset className="col-md-4 col-sm-12">
                    <TextField
                      fullWidth
                      required="true"
                      label="Hotel Code"
                      id="outlined-size-small"
                      size="small"
                      variant="outlined"
                      name="code"
                      value={data.code}
                      onChange={changeHandler}
                    />
                  </fieldset>
                  <fieldset className="col-md-8 col-sm-12">
                    <TextField
                      fullWidth
                      required="true"
                      label="Hotel Name"
                      id="outlined-size-small"
                      size="small"
                      variant="outlined"
                      name="name"
                      value={data.name}
                      onChange={changeHandler}
                    />
                  </fieldset>
                </div>
 
                <div className="row my-1">
                  <div className="col-md-6 col-sm-12 d-flex ">
                    <div className="my-2">
                      <span>Created By : Jnanasoftware</span>
                    </div>
                 
                  </div>
                  <div className="col-md-6 col-sm-12 d-flex ">
                    <div className=" my-2">
                      <span>Modified By : {currentUser}</span>
                    </div>
                  </div>
                </div>
                <div className="row my-1">
                  <div className="col-md-6 col-sm-12 d-flex ">
                    <div className="">
                      <span>Created Time : {moment(data.createddate).format("DD-MM-YYYY")}</span>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12 d-flex ">
                    <div className="">
                      <span>Modified Time : {moment(data.modifieddate).format("DD-MM-yyyy")} </span>
                    </div>
                  </div>
                  <div className="btn d-flex justify-context-center">
                    <button className="btn buttonColour btn-sm  "  onClick={AddHandler}>Save</button>
                  </div>
                </div>
              </div>
            </form>
            
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default withRouter(MHotelTax);
